/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
/**
 * 
 * @export
 * @interface TokenUpdateResult
 */
export interface TokenUpdateResult {
    /**
     * 
     * @type {string}
     * @memberof TokenUpdateResult
     */
    accessToken: string;
}

export function TokenUpdateResultFromJSON(json: any): TokenUpdateResult {
    return TokenUpdateResultFromJSONTyped(json, false);
}

export function TokenUpdateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenUpdateResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
    };
}

export function TokenUpdateResultToJSON(value?: TokenUpdateResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': value.accessToken,
    };
}


